import type { Credential, CredentialFormData } from "@/lib/queries/credentials";
import { api } from "@/lib/http";

function list() {
  return api.auth.raw.get("api/v1/credentials/").json<Array<Credential>>();
}

function create(data: CredentialFormData) {
  return api.auth.raw.post("api/v1/credentials/", { json: data }).json<Credential>();
}

function update(id: number, data: CredentialFormData) {
  return api.auth.raw
    .patch(`api/v1/credentials/${id}`, { json: data })
    .json<Credential>();
}

function remove(id: number) {
  return api.auth.raw.delete(`api/v1/credentials/${id}`);
}

export default {
  list,
  create,
  update,
  remove,
};
